import {
  DiffOutlined,
  DollarCircleOutlined,
  SwapOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import CountUpMoney from "../../../components/other/countUpMoney";
import GetMerchantSummaryCount from "../../../functions/admin/getMerchantSummaryCount";
import { useAdmin } from "../../../context/adminContext";

const CountGraph = () => {
  const { activeMerchantId } = useAdmin();
  const [realData, setRealData] = useState([]);

  const baseData = [
    {
      title: "Харилцагчид",
      icon: <UserOutlined className="text-[30px] text-green-500" />,
    },
    {
      title: "Нэхэмжлэл",
      icon: <DiffOutlined className="text-[30px] text-green-500" />,
    },
    {
      title: "Гүйлгээ",
      icon: <SwapOutlined className="text-[30px] text-green-500" />,
    },
    {
      title: "Орлого",
      icon: <DollarCircleOutlined className="text-[30px] text-green-500" />,
    },
  ];

  useEffect(() => {
    if (activeMerchantId) fetchCounts();
  }, [activeMerchantId]);

  const fetchCounts = async () => {
    const response = await GetMerchantSummaryCount(activeMerchantId);
    const updated = [...baseData];
    updated[0].count = response.vatMerchantCount;
    updated[1].count = response.invoiceCount;
    updated[2].count = response.transactionCount;
    updated[3].count = response.incomeSum[0]?.total_amount || 0;
    setRealData(updated);
  };

  return (
    <Row gutter={[24, 24]} justify="center" className="my-4">
      {realData.map((item, index) => (
        <Col xs={12} sm={12} md={6} key={index}>
          <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition p-4 flex items-center gap-4 justify-start min-h-[100px] text-gray-800">
            {/* Icon */}
            <div className="text-green-500 text-3xl">{item.icon}</div>

            {/* Content */}
            <div>
              <div className="text-sm font-medium text-gray-600 leading-tight">
                {item.title}
              </div>
              <div className="text-xl font-bold mt-1">
                {item.title === "Орлого" ? (
                  <CountUpMoney money={item.count} />
                ) : (
                  <CountUp end={item.count} duration={1.2} separator="," />
                )}
              </div>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default CountGraph;
